import Experience from '../../Experience.js'
import * as THREE from 'three'

export default class Raycaster {
    constructor()
    {
        this.experience = new Experience()
        this.mouse = this.experience.input.mouse
        this.camera = this.experience.camera.instance
        this.witness = null

        this.instance = new THREE.Raycaster()
    }

    update()
    {
        this.instance.setFromCamera(this.mouse, this.camera)
    }
}